/* eslint-disable react/prop-types */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/jsx-closing-bracket-location */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCard.css';
import { SelectField,TextField,DateField,EditFormButton,AutocompleteField,Icon,Switcher,MessageBox } from 'component-lib';
import { DateTimeHelper,RoleConfiguration,TranslateGender } from 'utils-lib';
import { CustomerModel, RequestAjaxClass, RequestJsonClass, StreetsModel, Customer } from 'models-lib';

var moment = require('moment');
moment().format();
var getStreets = true;
var streetIndex = 0;
var streetArrayLength = 0;

class CustomerData extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {};
    this.state.Edit = false;
    this.state.requiredFields = '';
    this.state.streets = [];
    this.state.curr = '';

    this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    
    this.GetJsonRequest = new RequestJsonClass();

    this.CustomerModel = new CustomerModel([this]);

    this.StreetsModel = new StreetsModel([this], "StreetsCustomer",this.Request);
  }

  componentWillMount(){
    $("#LoadingIcon").removeClass().addClass('loaderSmall');
  }

  componentDidMount(){
    this.Request.setApiUrl(Vas.ApiUrl);
    this.Request.setApiKey(Vas.ApiKey);
    this.Request.setAuth(true);
    this.CustomerModel.SetRequest(this.Request);
    //this.StreetsModel.SetRequest(this.Request);
    this.load(false);

    let reqFields = [this.refs.name, this.refs.firstName,this.refs.dateOfBirth,this.refs.zip, this.refs.city,this.refs.houseNumber, this.refs.street];

    this.setState({ requiredFields:reqFields, 
      //requiredSelectField:[this.refs.gender] 
    });

    document.getElementById("Salutation").onselectstart = function(){return false;};
    document.getElementById("Salutation").onmousedown = function(){return false;};

    document.getElementById("CustomerNumber").onselectstart = function(){return false;};
    document.getElementById("CustomerNumber").onmousedown = function(){return false;};

    document.getElementById("email").onselectstart = function(){return false;};
    document.getElementById("email").onmousedown = function(){return false;};

    document.onselectstart = function(){
      return false;
    };

    $("#LoadingIcon").removeClass().addClass('hide');
  }

  componentDidUpdate()
  {
    let me = this;
    if (this.state.Edit === false)
    {
      getStreets = true;

      me.refs.name.setState({ editable:false });
      me.refs.firstName.setState({ editable:false });
      me.refs.adressAddition.setState({ editable:false });
      me.refs.zip.setState({ editable:false });
      me.refs.city.setState({ editable:false });
      me.refs.houseNumber.setState({ editable:false });
      me.refs.houseNumberAddition.setState({ editable:false });
      me.refs.phone.setState({ editable:false });
      if(this.CustomerModel !== undefined){
        if(this.CustomerModel.Customer !== undefined){
          if(this.CustomerModel.Customer.DateOfBirth !== undefined){
            if(this.CustomerModel.Customer.DateOfBirth.length > 0){
              document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')));
            }
          }
        }
      }
      
      this.refs.street.setState({ editable:false });
      this.refs.GradeLevel.setState({ editable:false });
      this.refs.Class.setState({ editable:false });

      document.getElementById("Name1").onselectstart = function(){return false;};
      document.getElementById("Name1").onmousedown = function(){return false;};

      document.getElementById("Name2").onselectstart = function(){return false;};
      document.getElementById("Name2").onmousedown = function(){return false;};

      document.getElementById("Gender").onselectstart = function(){return false;};
      document.getElementById("Gender").onmousedown = function(){return false;};

      document.getElementById("DateOfBirth").onselectstart = function(){return false;};
      document.getElementById("DateOfBirth").onmousedown = function(){return false;};

      document.getElementById("AdressAddition").onselectstart = function(){return false;};
      document.getElementById("AdressAddition").onmousedown = function(){return false;};

      document.getElementById("Zip").onselectstart = function(){return false;};
      document.getElementById("Zip").onmousedown = function(){return false;};

      document.getElementById("City").onselectstart = function(){return false;};
      document.getElementById("City").onmousedown = function(){return false;};

      document.getElementById("Street").onselectstart = function(){return false;};
      document.getElementById("Street").onmousedown = function(){return false;};

      document.getElementById("HouseNumber").onselectstart = function(){return false;};
      document.getElementById("HouseNumber").onmousedown = function(){return false;};

      document.getElementById("HouseNumberAddition").onselectstart = function(){return false;};
      document.getElementById("HouseNumberAddition").onmousedown = function(){return false;};

      document.getElementById("Phone").onselectstart = function(){return false;};
      document.getElementById("Phone").onmousedown = function(){return false;};

      document.getElementById("GradeLevel").onselectstart = function(){return false;};
      document.getElementById("GradeLevel").onmousedown = function(){return false;};

      document.getElementById("Class").onselectstart = function(){return false;};
      document.getElementById("Class").onmousedown = function(){return false;};
    }
    else
    {
      this.refs.name.setState({ editable:true });
      this.refs.firstName.setState({ editable:true });
      this.refs.adressAddition.setState({ editable:true });
      this.refs.zip.setState({ editable:true });
      this.refs.city.setState({ editable:true });
      this.refs.houseNumber.setState({ editable:true });
      this.refs.houseNumberAddition.setState({ editable:true });
      this.refs.phone.setState({ editable:true });
      this.refs.street.setState({ editable:true });
      this.refs.GradeLevel.setState({ editable:true });
      this.refs.Class.setState({ editable:true });

      document.getElementById("Name1").onselectstart = function(){return true;};
      document.getElementById("Name1").onmousedown = function(){return true;};

      document.getElementById("Name2").onselectstart = function(){return true;};
      document.getElementById("Name2").onmousedown = function(){return true;};

      document.getElementById("Gender").onselectstart = function(){return true;};
      document.getElementById("Gender").onmousedown = function(){return true;};

      document.getElementById("DateOfBirth").onselectstart = function(){return true;};
      document.getElementById("DateOfBirth").onmousedown = function(){return true;};

      document.getElementById("AdressAddition").onselectstart = function(){return true;};
      document.getElementById("AdressAddition").onmousedown = function(){return true;};

      document.getElementById("Zip").onselectstart = function(){return true;};
      document.getElementById("Zip").onmousedown = function(){return true;};

      document.getElementById("City").onselectstart = function(){return true;};
      document.getElementById("City").onmousedown = function(){return true;};

      document.getElementById("Street").onselectstart = function(){return true;};
      document.getElementById("Street").onmousedown = function(){return true;};

      document.getElementById("HouseNumber").onselectstart = function(){return true;};
      document.getElementById("HouseNumber").onmousedown = function(){return true;};

      document.getElementById("HouseNumberAddition").onselectstart = function(){return true;};
      document.getElementById("HouseNumberAddition").onmousedown = function(){return true;};

      document.getElementById("Phone").onselectstart = function(){return true;};
      document.getElementById("Phone").onmousedown = function(){return true;};

      document.getElementById("GradeLevel").onselectstart = function(){return true;};
      document.getElementById("GradeLevel").onmousedown = function(){return true;};

      document.getElementById("Class").onselectstart = function(){return true;};
      document.getElementById("Class").onmousedown = function(){return true;};

      document.getElementById("Street").selectedIndex = streetIndex < streetArrayLength ? streetIndex + 1 : streetIndex;
    }
  }
  
  load(){
    $("#LoadingIcon").removeClass().addClass('loaderSmall');
    this.Request.setErrorHandler(()=>{
      $("#LoadingIcon").removeClass().addClass('hide');
    });
    let role = localStorage.getItem("vas_role");

    if(role === "1"){
      this.CustomerModel.GetCustomerById(this.props.id);
    } else if(role === "3" || role === "99"){
      var sendData = "?limit=10&start=0&customerCategory=Abo";
      this.CustomerModel.GetCustomers(sendData,null,null,"name1",null,"Abo",null,null,null,null,null,this.props.id,null,null,null);
    }
  }
  
  setCustomer(Customer){
    this.setState({},()=>{

      //TODO: save CustomerId;

      let me = this;
      if (me.refs){
        document.getElementById('CustomerNumber').value = Customer.CustomerNumber;
        document.getElementById('Salutation').value = Customer.Gender == "männlich" || Customer.Gender == "male" ? "Herr" : Customer.Gender == "weiblich" || Customer.Gender == "female" ? "Frau": "";
        document.getElementById('Name1').value = Customer.Name1;
        document.getElementById('Name2').value = Customer.Name2;
        document.getElementById('Gender').value = Customer.Gender;
        document.getElementById('DateOfBirth').value = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(Customer.DateOfBirth,true,localStorage.getItem('vas_language')));
        document.getElementById('Zip').value = Customer.PostCode;
        document.getElementById('City').value = Customer.City;
        document.getElementById('Street').value = Customer.Street;
        document.getElementById('AdressAddition').value = Customer.Name3;
        document.getElementById('HouseNumber').value = Customer.HouseNumber;
        document.getElementById('HouseNumberAddition').value = Customer.HouseNumberAddition;
        document.getElementById('Phone').value = Customer.Phone;
        document.getElementById('email').value = Customer.Email;
        document.getElementById('Class').value = Customer.Class;
        document.getElementById('GradeLevel').value = Customer.GradeLevel !== 0?Customer.GradeLevel:'';

        localStorage.setItem("Birthdate", Customer.DateOfBirth);
        localStorage.setItem("Id_CurrentCustomer", Customer.Id);
        localStorage.setItem("Number_CurrentCustomer", Customer.CustomerNumber);
      }
    });

    $("#LoadingIcon").removeClass().addClass('hide');
  }

  Update(observer){
    let me = this;
    this.setState({},()=>{
      if(observer === "StreetsCustomer"){

        let streetSelection = [];

        if(this.StreetsModel.Streets.length > 0){

          let streetArray = this.StreetsModel.Streets;

          streetArrayLength = streetArray.length;

          for(let i = 0; i < streetArray.length; i++){
            if(streetArray[i] == this.CustomerModel.Customer.Street){
                streetIndex = i;
            }
            streetSelection.push({ Key: streetArray[i], Display: streetArray[i] });
          }      
        }

        this.setState({StreetValues : streetSelection});
         if(this.refs.street){
           this.refs.street.setState({Data:streetSelection});
         }

        this.setState({oldZipstreet: this.StreetsModel.PostCode, oldCitystreet: this.StreetsModel.City });
      }
      else if(observer === "Customer"){
        $("#LoadingIcon").removeClass().addClass('hide');
        this.setCustomer(this.CustomerModel.Customer);
      }
      else if(observer === "Streets"){
        me.refs.street.setState({ Data: this.StreetsModel.Streets, Icon :'',placeholder:'' });
        me.setState({oldZip: this.StreetsModel.PostCode, oldCity: this.StreetsModel.City });
      } 
      else if(observer === "CustomerPUT"){
        $("#LoadingIcon").removeClass().addClass('hide');
        this.setCustomer(this.CustomerModel.Customer);
        me.props.reference.GetCustomer();
      }
      else if(observer === "Customers"){
          if (this.CustomerModel.Customers)
          {         
              this.CustomerModel.Customers.forEach(function(value) {
                  me.setCustomer(value); 
                  me.CustomerModel.Customer = value;           
              });
          }

          $("#LoadingIcon").removeClass().addClass('hide');
      }
    });
  }

  checkFields(){
    let count;
    if (this.state.requiredFields){
      count = this.state.requiredFields.length;

      let filled = 0; //Anzahl der korrekt gefüllten Feldern 
      for (let i = 0;i < this.state.requiredFields.length;i++){
        
        if (this.state.requiredFields[i]){
          if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0 
            || document.getElementById(this.state.requiredFields[i].props.Id).placeholder.length > 0){
              if(!(/^\s+$/).test(document.getElementById(this.state.requiredFields[i].props.Id).value)){
                filled++;
              }
          }
        }
      }

      // for (let k = 0; k < this.state.requiredSelectField.length;k++){
      //   if (this.state.requiredSelectField[k]){
      //     if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex > 0){
      //       filled++;
      //     }
      //   }
      // }

      if (filled < count){
        return false;
      } else {
        return true;
      }
    }
  }

  CustomerUpdate()
  {   
    if (this.checkFields()=== true){
      this.PostCustomer();
      this.setState({oldCity:'',oldZip:''});
    } else {
      ReactDOM.render(<MessageBox
        Message={Vas.Resources.Labels["NotAllFields"]}
        Title={Vas.Resources.Titles["Note"]}
      />,document.getElementById('messageContainer'));
      this.load(false);
    }
  }

  PostCustomer(){

      if (this.CustomerModel.Customer.Name1.length > 0 && this.CustomerModel.Customer.Name2.length > 0 && DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true, localStorage.getItem('vas_language')).isValid() === true){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');

        this.CustomerModel.UpdateCustomer();
      } 
  }

  getStreets()
  {
    let me = this;
    me.refs.street.setState({ Icon:"Loop" });

    if ((me.CustomerModel.Customer.PostCode !== me.state.oldZip)||(me.CustomerModel.Customer.City !== me.state.oldCity)){
      me.refs.street.setState({ Data: [], Icon : '' });
      document.getElementById("Street").value = '';
    }

    if (me.CustomerModel.Customer.City || me.CustomerModel.Customer.PostCode){
      let city = '';
      let zip = '';
      if (me.CustomerModel.Customer.City){
        city=me.CustomerModel.Customer.City;
      } else {
        city = document.getElementById("City").placeholder;
      }
      if (me.CustomerModel.Customer.PostCode){
        zip=me.CustomerModel.Customer.PostCode;
      } else {
        zip = document.getElementById("Zip").placeholder;
      }

      this.StreetsModel.GetStreets(city,zip);
    }
  }

  Cancel(){
    this.setState({oldZip:'',oldCity:''},()=>{
      this.load();
    });
    
  }

  showChangeEmail(){
    Vas.GetView("ChangeMail", {CustomerId: this.props.id, Email: this.CustomerModel.Customer.Email},true);
    //ReactDOM.render(<ChangeEmail />,document.getElementById('popupContainer'));
  }

  Switch(){
    if (this.refs.noMail){
      this.CustomerModel.Customer.NoMail = !this.refs.noMail.state.on;
      this.PostCustomer();
    }
  }

  bindStreets(){
    if(this.state.Edit && getStreets){
      this.getStreets();

      getStreets = false;
    }
  }

  render()
  {
    let rights = RoleConfiguration.getRoleConfig();
    let role = localStorage.getItem("vas_role");
          

    let min = moment();
    let minValue = moment([min.year() - Vas.Config.PupilMaxAge, min.month(), min.date() +1]); //minValue für Geburtsdatums Datepicker nicht älter als 18 Jahre
    let maxValue = moment([min.year() - 6, min.month(), min.date()]); //moment(); //maxValue für Geburtsdatums DatePicker max 6 Jahre jung
    

    let gender = '';
    let birth = '';
    let street = '';
    let name = '';
    let firstName = '';
    let adressAddition = '';
    let zip = '';
    let city = '';
    let houseNumber = '';
    let houseNumberAddition = '';
    let phone = '';
    if (this.CustomerModel.Customer.Gender){
      gender = (<TextField 
        AppURL={Vas.ApplicationUrl} 
        Editable={false} 
        Id={"Gender"} 
        Label={Vas.Resources.Labels["Gender"]} 
        ref={"gender"} 
        Value={TranslateGender.Translate(this.CustomerModel.Customer.Gender,localStorage.getItem('vas_language'))}
      />);
    } else {
      gender = (<TextField 
        AppURL={Vas.ApplicationUrl} 
        Editable={false} 
        Id={"Gender"} 
        Label={Vas.Resources.Labels["Gender"]}
        ref={"gender"}
      />);
    }
        
    birth = (<TextField 
      AppURL={Vas.ApplicationUrl}
      Editable={false} 
      Id={"DateOfBirth"} 
      Label={Vas.Resources.Labels["DateOfBirth"]} 
      ref={"dateOfBirth"}
    />);

    street = (<AutocompleteField 
      AppURL={Vas.ApplicationUrl}
      Data={this.StreetsModel.Streets} 
      editable={false}
      Float={'left'}
      Id={"Street"}
      IsRequired={true} 
      Label={Vas.Resources.Labels["Street"]}
      MessageFalseStreet={Vas.Resources.Labels["FalseStreet"]}
      Modus={"Street"}
      OnBlur={()=>{if($("#Street").val().length === 0){$("#Street").val(this.refs.street.state.Placeholder);} else {this.CustomerModel.Customer.Street = $("#Street").val();}}}
      ref={"street"}
      TitleMessageFalseStreet={Vas.Resources.Labels["Error"]} 
      Tooltip={Vas.Resources.Tooltips["Street"]}  
      Width={346}
      TimeOutTime={Vas.TimeOutTime}
    />);
    name = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false} 
      Id={"Name1"} 
      Label={Vas.Resources.Labels["Name"]}
      OnBlur={()=>{
        if ($("#Name1").val().length === 0){$("#Name1").val(this.CustomerModel.Customer.Name1);} else {this.CustomerModel.Customer.Name1 = $("#Name1").val();}
      }}
      ref={"name"} 
      Modus={"Name"}
    />);
    firstName = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false} 
      Id={"Name2"} 
      Label={Vas.Resources.Labels["FirstName"]} 
      OnBlur={()=>{if ($("#Name2").val().length === 0){$("#Name2").val(this.CustomerModel.Customer.Name2);} else {this.CustomerModel.Customer.Name2 = $("#Name2").val(); }}}
      ref={"firstName"} 
      Modus={"Name"}
    />);
    adressAddition = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false} 
      Id={"AdressAddition"}
      Label={Vas.Resources.Labels["AdditionAdress"]} 
      OnChange={()=>{ this.CustomerModel.Customer.Name3 = $("#AdressAddition").val(); }}
      ref={"adressAddition"} 
      Width={346} 
    />);
    zip = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false}
      Id={"Zip"} 
      Label={Vas.Resources.Labels["Zip"]} 
      OnChange={()=>{if ($("#Zip").val().length < 0)
                      {$("#Zip").val(this.CustomerModel.Customer.PostCode);} 
                    else {this.CustomerModel.Customer.PostCode = $("#Zip").val();this.getStreets(); streetIndex = -1;}}}
      ref={"zip"} 
      Modus={"Number"}
    />);
    city = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false}
      Id={"City"} 
      Label={Vas.Resources.Labels["Place"]} 
      OnChange={()=>{if ($("#City").val().length < 0)
                        {$("#City").val(this.CustomerModel.Customer.City);} 
                    else {this.CustomerModel.Customer.City = $("#City").val();this.getStreets(); streetIndex = -1;}}}
      ref={"city"} 
    />);
    houseNumber = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false}
      Id={"HouseNumber"} 
      Label={Vas.Resources.Labels["HouseNumber"]}
      OnBlur={()=>{if ($("#HouseNumber").val().length === 0){$("#HouseNumber").val(this.CustomerModel.Customer.HouseNumber);} else {this.CustomerModel.Customer.HouseNumber = $("#HouseNumber").val();}}}
      ref={"houseNumber"} 
      Modus={"Number"}
    />);
    houseNumberAddition = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false}
      Id={"HouseNumberAddition"} 
      Label={Vas.Resources.Labels["HouseNumberAddition"]} 
      OnChange={()=>{ this.CustomerModel.Customer.HouseNumberAddition = $("#HouseNumberAddition").val(); }}
      ref={"houseNumberAddition"} 
    />);
    phone = (<TextField 
      AppURL={Vas.ApplicationUrl} 
      Editable={false}
      Id={"Phone"} 
      Label={Vas.Resources.Labels["Phone"]} 
      OnChange={()=>{ this.CustomerModel.Customer.Phone = $("#Phone").val(); }}
      ref={"phone"}
      TitleMessageNotValidNumber={Vas.Resources.Labels["Note"]} 
      MessageNotValidNumber={Vas.Resources.Labels["NotValidNumber"]} 
      Modus={"TelNumber"} 
    />);
        
    if (this.state.Edit === true){

      street = (<SelectField
        AppURL={Vas.ApplicationUrl}
        TitleMessageFalseStreet={Vas.Resources.Labels["Error"]}
        me={this}
        Width={350}
        ref={"street"}
        Id={"Street"}
        Float={'left'} 
        IsRequired={true}
        editable={true}
        Modus={"Street"}
        Data={this.StreetValues}
        Label={Vas.Resources.Labels["Street"]}
        OnBlur={()=>{this.CustomerModel.Customer.Street = $("#Street").val();}}
        Tooltip={Vas.Resources.Tooltips["Street"]}
        TimeOutTime={Vas.TimeOutTime}/>);

      gender = (<SelectField 
        AppURL={Vas.ApplicationUrl} 
        Data={[{ Key: 'männlich', Display: Vas.Resources.Labels["Male"] },{ Key: 'weiblich', Display: Vas.Resources.Labels["Female"] },{ Key: 'divers', Display: Vas.Resources.Labels["Divers"] }]}
        Default={document.getElementById('Gender').value}
        Id={"Gender"}
        IsRequired={false}
        Label={Vas.Resources.Labels["Gender"]}
        OnChange={()=>{
          if(document.getElementById('Gender').selectedIndex >= 0){
            this.CustomerModel.Customer.Gender = TranslateGender.Translate($("#Gender").val(),localStorage.getItem('vas_language'));
          }
        }}
        ref={"gender"}
        Tooltip={Vas.Resources.Tooltips["Gender"]}
        SelectFieldChooseText={Vas.Resources.Labels["NotSpecified"]} />);
      if (role === "1"){
        birth = (<DateField 
          AppURL={Vas.ApplicationUrl}
          Language={localStorage.getItem("vas_language")} 
          Editable={true} 
          ref={"dateOfBirth"} 
          MaxValue={maxValue}
          MinValue={minValue}
          IsRequired={true} 
          Id={"DateOfBirth"}  
          Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
          Label={Vas.Resources.Labels["DateOfBirth"]}
          OnBlur={()=>{if($("#DateOfBirth").val().length === 0){
            $("#DateOfBirth").val(DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language'))));
          }else {
            let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language')) ;
            this.CustomerModel.Customer.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00"); 
          }
        }}
          FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
          Placeholder={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')))}
        />);
      } else {
        birth = (<DateField 
          AppURL={Vas.ApplicationUrl}
          Language={localStorage.getItem("vas_language")} 
          Editable={true} 
          ref={"dateOfBirth"} 
          MaxValue={maxValue} 
          IsRequired={true} 
          Id={"DateOfBirth"}  
          Tooltip={Vas.Resources.Tooltips["DateOfBirth"]} 
          Label={Vas.Resources.Labels["DateOfBirth"]}
          OnBlur={()=>{if($("#DateOfBirth").val().length === 0){
            $("#DateOfBirth").val(DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language'))));
          }else {
            let cur = DateTimeHelper.StringToDate($("#DateOfBirth").val(),false,localStorage.getItem('vas_language')) ;
            this.CustomerModel.Customer.DateOfBirth = moment([cur.year(),cur.month(),cur.date()]).format("YYYY-MM-DDT00:00:00"); 
          }
        }}
          FalseMaxDateText={Vas.Resources.Labels["NoFutureDateOfBirth"]}
          Placeholder={DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem('vas_language')))}
        />);
      }
    }
           
    let right = '';
    let formButton = '';
    let emailIcon = (<Icon 
      Color={"grey"}
      Name={"Create"}  
      ref={"emailIcon"} 
      Size={24} 
    />);
    if (role === "1"){
      if (rights[1]){
        right = rights[1];
        if (right.Edit === true){
          emailIcon = (<Icon
            Color={"black"} 
            Name={"Create"}
            ref={"emailIcon"} 
            Size={24} 
            OnClick={()=>{this.showChangeEmail();}}
          />);
        }
      }
    }
    if (role === "3" || role === "99"){
      if (rights[0]){
        right = rights[0];
      }
    }
    formButton = (<EditFormButton 
      AppURL={Vas.ApplicationUrl} 
      base={this} 
      curr={this.CustomerModel.Customer}
      id={this.props.id}
      ref={"EditFormButton"} 
      Right={right} 
    />);

    let noMailtrue = <div></div>;
    let noMailfalse = <div></div>;
    if (this.CustomerModel.Customer.NoMail !== undefined){
      if (this.CustomerModel.Customer.NoMail === true){
        noMailtrue = (<Switcher
          Id={"NoMail"}
          On={false}
          ref={"noMail"}
          OnClick={()=>{this.Switch();}} />);
      } else {
        noMailfalse = (<Switcher
          Id={"NoMail"}
          On={true}
          ref={"noMail"}
          OnClick={()=>{this.Switch();}} />);
      }
    }
    
    return (
      <table style={{ marginTop:10, marginLeft:10 }}>
        <tbody>
          <tr>
            <td className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["PersonalData"]}</b></td>
            <td>{formButton}</td>
          </tr>
          <tr>
            <td>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Editable={false}
                Id={"Salutation"}
                Label={Vas.Resources.Labels["Salutation"]} 
                ref={"Salutation"} 
              /> 
            </td>
            <td>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Editable={false}
                Id={"CustomerNumber"}
                Label={Vas.Resources.Labels["CustomerNumber"]} 
                ref={"CustomerNumber"} 
              />
            </td>
          </tr>
          <tr>
            <td>{name} </td>
            <td>{firstName} </td>
          </tr>
          <tr>
            <td>{gender}</td>
            <td>{birth}</td>
          </tr>
          <tr>
            <td>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Editable={false} 
                Id={"GradeLevel"}
                Label={Vas.Resources.Labels["GradeLevel"]}
                OnChange={()=>{ this.CustomerModel.Customer.GradeLevel = $("#GradeLevel").val(); }}
                ref={"GradeLevel"} 
                Modus={"Number"}
              />
            </td>
            <td>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Editable={false} 
                Id={"Class"} 
                Label={Vas.Resources.Labels["Class"]} 
                OnChange={()=>{ this.CustomerModel.Customer.Class = $("#Class").val(); }}
                ref={"Class"} 
                Modus={"Char"}
              />
            </td>
          </tr>
          <tr><td><br /></td></tr>
          <tr>
            <td 
              colSpan={2} 
              className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ContactData"]}</b></td>
          </tr>
          <tr>
            <td colSpan={2}>{adressAddition}</td>
          </tr>
          <tr>
            <td>{zip}</td>
            <td>{city}</td>
          </tr>
          <tr>
            <td colSpan={2} onBlur={this.bindStreets()}>{street}</td>
          </tr>
          <tr>
            <td>{houseNumber}</td>
            <td>{houseNumberAddition}</td>
          </tr>
          <tr >
            <td colSpan={2}>
              <TextField 
                AppURL={Vas.ApplicationUrl} 
                Editable={false}
                Id={"email"}
                Label={Vas.Resources.Labels["Email"]}
                ref={"email"} 
                Width={316} 
              />
              {emailIcon}
            </td>
          </tr>
          <tr>
            <td>{phone}</td>
          </tr>
          <tr>
            <td 
              colSpan={2} 
              style={{ width:'316px' }}>
              <br />
              {Vas.Resources.Labels["ChangeStatus"]}:
            </td>
          </tr>
          <tr>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td style={{ paddingTop:"20px" }}>
                      {Vas.Resources.Labels["No"]}
                    </td>
                    <td>
                      {noMailtrue}{noMailfalse}
                    </td>
                    <td style={{ paddingTop:"20px" }}>
                      {Vas.Resources.Labels["Yes"]}   
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
export default CustomerData;
